var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro",on:{"click":_vm.start}},[_c('img',{attrs:{"src":require("../assets/NADA01_iPad.jpg"),"alt":"Introducing OnStar Guardian App"}})])}
var staticRenderFns = []

export { render, staticRenderFns }